/**
 * Props should include a set of menu items with intended hash values
 * props.menuItems is an array of menu objects
 * props.current is the
 * The parent will react to changes in the window location and re-render
 * the relevant collections accordingly.
 */

/**
 *
 * TODO:
 * Should default highlight the first item when there is no hash
 *
 * Other values will likely work but won't match anything so no highlights
 *
 *
 *
 *
 *
 */

export const FilterMenu = (props) => {
  const menuItems = props.items.map((item, n) => {
    // console.log({ n, item });
    const hash = n === 0 ? "" : `#${item.object_slug}`;
    const className = hash === props.current ? "current_page_item" : null;
    const clickHandler =
      n === 0
        ? (e) => {
            e.preventDefault();
            const popstate = new PopStateEvent("popstate"); /// send synthetic event to trigger an update
            history.pushState("", document.title, window.location.pathname);
            window.dispatchEvent(popstate);

            console.log("click handler");
          }
        : null;

    return (
      <li key={"menu" + item.id} className={className}>
        <a onClick={clickHandler} href={hash}>
          {item.title}
        </a>
      </li>
    );
  });

  return (
    <div
      className="global-spacing--page-header js-ga-track-links"
      data-ga-action="Filter"
      data-ga-label=":text"
    >
      <nav className="grid subnav subnav--filter">
        <ul id="menu-capability-filters" className="subnav__main">
          {menuItems}
        </ul>
      </nav>
    </div>
  );
};
